<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="$modal.closeModal"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionBillingPaymentMethodsModalActionDisabled.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>{{ $t('mEditionBillingPaymentMethodsModalActionDisabled.message') }}</p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingPaymentMethodsModalActionDisabled',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionBillingPaymentMethodsModalActionDisabled.buttonPrimary'),
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      }
    }
  }
}
</script>
